// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCJvRigm0w9HnbDAErC3R5M9nW-Kmvv1D4",
  authDomain: "payo-terminal.firebaseapp.com",
  projectId: "payo-terminal",
  storageBucket: "payo-terminal.appspot.com",
  messagingSenderId: "436357162526",
  appId: "1:436357162526:web:03edb15263824f66b4300f",
  measurementId: "G-P7HL83N2YQ",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
